import { _axios } from '@/plugins/axios';

class UserService {
  /**
   * Get all users
   * @returns {Promise} API response
   */
  getUsers() {
    return _axios.get('/api/v1/admin/users');
  }

  /**
   * Get a single user by ID
   * @param {string} userId - The user ID
   * @returns {Promise} API response
   */
  getUser(userId) {
    return _axios.get(`/api/v1/admin/users/${userId}`);
  }

  /**
   * Create a new user
   * @param {Object} userData - User data object
   * @returns {Promise} API response
   */
  createUser(userData) {
    return _axios.post('/api/v1/admin/users', userData);
  }

  /**
   * Update an existing user
   * @param {string} userId - The user ID
   * @param {Object} userData - Updated user data
   * @returns {Promise} API response
   */
  updateUser(userId, userData) {
    return _axios.put(`/api/v1/admin/users/${userId}`, userData);
  }

  /**
   * Delete a user
   * @param {string} userId - The user ID to delete
   * @returns {Promise} API response
   */
  deleteUser(userId) {
    return _axios.delete(`/api/v1/admin/users/${userId}`);
  }

  /**
   * Get current logged in user info
   * @returns {Promise} API response
   */
  getCurrentUser() {
    return _axios.get('/api/v1/profile');
  }
}

export default new UserService();
